<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="listing-header mb-3 is-flex-vcenter">
            <div class="title-breadcrumb">
                <h1 class="title p-0">
                    {{ isUpdate ? $t('editar-paleta') : $t('criar-paleta') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"    
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="form-columns-fit">
            <div class="columns is-flex-column">
                <div class="column">
                    <v-input
                        ref="nomeInput"
                        :title="'nome'"
                        v-model="paleta.nome"
                    />
                </div>
                <div class="is-flex">
                    <div class="column is-flex is-flex-vbottom flex-gap">
                        <v-input
                            ref="corPrimariaInput"
                            :title="'cor-primaria'"
                            v-model="paleta.primaria"
                            :maxlength="7"
                        />

                    <span class="pb-3">
                        <input 
                            class="paleta"
                            type="color" 
                            id="head"                                 
                            v-model="paleta.primaria" 
                                name="head" />
                    </span>
                    </div>
                    <div class="column is-flex is-flex-vbottom flex-gap">
                        <v-input
                            ref="corPrimariaInput"
                            :title="'cor-secundaria'"
                            v-model="paleta.secundaria"
                            :maxlength="7"
                        />
                        <span class="pb-3">
                    <input 
                        class="paleta"
                        type="color" 
                        id="head"                                 
                        v-model="paleta.secundaria" 
                        name="head" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import B2BCoresService from "@/services/b2b/B2BCoresService";
// COMPONENTS
import B2BCoresValidation from "@/services/validations/b2b/B2BCoresValidation";

export default {
    props: {
        paletaSelecionada: {
            type: Object,
            default: () => ({
                id: 0
            })
        },
    },
    data() {
        return {
            paleta: {
                id: 0,
                nome: '',
                primaria: '#000000',
                secundaria: '#000000'
            },
            isUpdate: null,
            service: new B2BCoresService(this.$http, this.$router),
            isLoading: false,
            validate: null,
        }
    },
    created() {
        this.isUpdate = Boolean(this.paletaSelecionada)
        this.validation = new B2BCoresValidation(this.$root.msgs);

        if(this.isUpdate) {
            this.carregarDados();
        }
    },
    methods: {
        carregarDados() {
            this.service
            .find(this.paletaSelecionada.id)
            .then(({content}) => {
                if(content){
                    const {id, descricao: nome, primary: primaria, secondary: secundaria} = content;

                    this.paleta = {
                        id,
                        nome,
                        primaria, 
                        secundaria
                    }
                }
            })
            .catch(e => {
                this.$root.showMessage('error', 'msg-erro-load');
            })
        },
        save() {
            const lotTemp = this.mapOnSave(this.paleta)
            
            if (this.validation.validate(lotTemp, this.$refs)) {
                this.isLoading = true;
                this.service
                .save(lotTemp)
                .then(({content: { id }}) => {
                    this.$emit('updatePaletaSelecionada', id);
                    
                    this.$root.showMessage('success', this.isUpdate ? 'msg-sucesso-ao-editar-cor' : 'msg-sucesso-ao-criar-cor');
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally(_ => {
                    this.isLoading = false;
                    this.onFecharModal();
                });
            }
        },
        mapOnSave({id, nome, primaria, secundaria}){
            return {
                id: id,
                descricao: nome,
                primary: this.colorFormatter(primaria),
                secondary: this.colorFormatter(secundaria)
            };
        },
        generateId(numberId){
            return this.$route.name+'-b2b-'+numberId;
        },
        onFecharModal(){
            this.$emit('fecharModal', true);
        },
        colorFormatter(color) {
            return color.toString('hex')
        }
    },
}
</script>


<style lang="scss" scoped>
.bg > #main {
    padding: 20px 20px;
}
.flex-gap {
    gap: 8px;
}

.regulagem-tamanho {
    height: 36px;
}

.pb-3 {
    padding-bottom: 7px !important;
}
.paleta {
    width: 40px; 
    height: 40px; 
    border: 0px; 
    padding: 0px !important;
    background-color: #FBFBFB;
}
</style>